module.exports = __webpack_public_path__ + "__static/site-1784740481084/img/octopus-english.b555d559.jpg";